import cx from 'classnames'
import { observer } from 'mobx-react-lite'
import { ALIGNMENT } from 'prose-core'

import { ReactComponent as AlignJustifyIcon } from 'assets/icons/alignJustify24.svg'
import { useAlignButtonToggle } from 'common/Prose/Toolbar/hooks/useAlignButtonToggle'
import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'

import Styles from '../MobileToolbar.module.scss'

export const JustifyButton = observer((props: ButtonProps) => {
  const { active, handleClick } = useAlignButtonToggle(ALIGNMENT.Justify)

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      aria-label="Align justify"
      className={cx(Styles.button, {
        [Styles.buttonSelected]: active,
      })}
      onClick={handleClick}
      data-testid="mobile-toolbar-align-justify-mark"
      {...props}
    >
      <AlignJustifyIcon />
    </Button>
  )
})
